/**
 * UTM 参数处理
 * 
 * 用于跨页面追踪广告来源
 */

/**
 * 从 URL 获取 UTM 参数
 * @returns {object} UTM 参数对象
 */
export function getUtmParams() {
  const params = new URLSearchParams(window.location.search)
  return {
    utm_source: params.get('utm_source') || '',
    utm_medium: params.get('utm_medium') || '',
    utm_campaign: params.get('utm_campaign') || '',
    utm_term: params.get('utm_term') || '',
    utm_content: params.get('utm_content') || ''
  }
}

/**
 * 保存 UTM 参数到 sessionStorage（用于跨页面追踪）
 */
export function saveUtmParams() {
  const utmParams = getUtmParams()
  if (utmParams.utm_source) {
    sessionStorage.setItem('utm_params', JSON.stringify(utmParams))
  }
}

/**
 * 获取保存的 UTM 参数
 * @returns {object} UTM 参数对象
 */
export function getSavedUtmParams() {
  try {
    const saved = sessionStorage.getItem('utm_params')
    return saved ? JSON.parse(saved) : {}
  } catch {
    return {}
  }
}
